
import {switchMap} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Detail } from "app/interfaces/detail.model";
import { Params, ActivatedRoute, Router } from "@angular/router";
import { DetailService } from "app/modules/project/services/detail.service";

@Component({
  selector: 'app-detail-form-container',
  templateUrl: './detail-form-container.component.html',
  styleUrls: ['./detail-form-container.component.scss']
})
export class DetailFormContainerComponent implements OnInit {
  fields: any = {};
  result: any = {};
  detail: Detail;

  constructor(
    private detailService: DetailService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.detailService.fields().subscribe(a => {
      this.fields = a;
    });

    this.route.params.pipe(
      // (+) converts string 'id' to a number
      switchMap((params: Params) => { return this.detailService.single(params['id'] || 0); }))
      .subscribe((item: any) => {
        this.detail = item;
      });
  }

  onNgSelectTyped(event) {
    console.log(event);
  }

  saveDetail(e: Detail) {
    this.detail = e;
    this.router.navigate([`/detail/${this.detail.Id}`]);
  }

  handleCancel(){
    this.router.navigate([`/detail/${this.detail.Id}`]);
  }
}
